// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1ppY8","content":"LoadingAlert_content__LOfEO"};